import React, { useMemo } from 'react';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import VolumeCapsuleSettings, {
    VolumeCapsuleSettingsClassName,
    VolumeCapsuleSettingsText,
} from 'widgets/liquiditySummary/volumeCapsule/components/settings/VolumeCapsuleSettings';
import { useVolumeCapsuleConfigSlice } from 'widgets/liquiditySummary/volumeCapsule/state/config/configslice';

import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { VolumeCapsuleContent } from 'widgets/liquiditySummary/volumeCapsule/components/VolumeCapsuleContent';
import VolumeCapsuleChartHelp from 'widgets/liquiditySummary/volumeCapsule/components/chart/help/VolumeCapsuleChartHelp';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { useVolumeCapsuleData } from 'widgets/liquiditySummary/volumeCapsule/components/volumeCapsuleData';
import classNames from 'classnames';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';

export function VolumeCapsule() {
    const { config, dispatchConfigChanged } = useVolumeCapsuleConfigSlice();

    useWidgetStream();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, []);

    const chartData = useVolumeCapsuleData();

    const { useWidgetMessages } = liquidityStreamedDataSelectors;
    const messages = useWidgetMessages();

    const cssClasses = classNames('VolumeCapsule');

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                settingsBody={<VolumeCapsuleSettings />}
                settingsHeader={VolumeCapsuleSettingsText}
                settingsClassName={VolumeCapsuleSettingsClassName}
                title={'Volume'}
                preceedingItems={<VolumeCapsuleChartHelp />}
                messages={messages}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <VolumeCapsuleContent
                        chartData={chartData}
                        config={config}
                        dispatchConfigChanged={dispatchConfigChanged}
                    />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    className={VolumeCapsuleSettingsClassName}
                    triggerText={'Capsule Settings'}
                    headerText={VolumeCapsuleSettingsText}
                    renderSettings={(p) => <VolumeCapsuleSettings {...p} />}
                />
                .
            </span>
        );
    }
}
